import axios from 'axios'

export default {
    namespaced: true,
    state: {
        roomTypes: []
    },
    mutations: {
        SET_TYPES(state, roomTypes) {
            state.roomTypes = roomTypes
        },
        ADD_RT(state, payload) {
            state.roomTypes.push(payload)
        },
        UPDATE_RT(state, payload) {
            const index = state.roomTypes.findIndex(
                item => item.id === payload.id
            )
            if (index !== -1) {
                Object.assign(state.roomTypes[index], payload)
            }
        },
        DEL_RT(state, payload) {
            const index = state.roomTypes.findIndex(
                item => item.id === payload
            )
            if (index !== -1) {
                state.roomTypes.splice(index, 1)
            }
        }
    },
    actions: {
        fetch({commit, dispatch}) {
            commit('TOGGLE_PRELOADER', true, {root: true})
            return new Promise((resolve) => {
                axios.get(
                    '/api/root/room-type'
                ).then(({data}) => {
                    commit('SET_TYPES', data.data)
                    resolve(data)
                }).finally(() => {
                    commit('TOGGLE_PRELOADER', false, {root: true})
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        add({dispatch, commit}, data) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/root/room-type',
                    data
                ).then(({data}) => {
                    commit('ADD_RT', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        edit({dispatch, commit}, item) {
            return new Promise((resolve) => {
                axios.put(
                    '/api/root/room-type/' + item.currentId,
                    item.editedItem
                ).then(({data}) => {
                    commit('UPDATE_RT', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        delete({dispatch, commit}, itemId) {
            return new Promise((resolve) => {
                axios.delete(
                    '/api/root/room-type/' + itemId
                ).then(() => {
                    commit('DEL_RT', itemId)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
    }
}

